import React, { useRef, useEffect } from 'react';
import { useLocation, Switch } from 'react-router-dom';
import AppRoute from './utils/AppRoute';
import ScrollReveal from './utils/ScrollReveal';
import ReactGA from 'react-ga';
import PrivacyPolicy from './views/Legal/PrivacyPolicy';
import TermsOfUse from './views/Legal/TermsofUse';

// Layouts
import LayoutDefault from './layouts/LayoutDefault';

// Views 
import Home from './views/Home';

// Initialize Google Analytics
ReactGA.initialize(process.env.REACT_APP_GA_CODE);

const trackPage = page => {
  ReactGA.set({ page });
  ReactGA.pageview(page);
};

const App = () => {

  const childRef = useRef();
  let location = useLocation();

  useEffect(() => {
    const page = location.pathname;
    document.body.classList.add('is-loaded')
    childRef.current.init();
    trackPage(page);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <ScrollReveal
      ref={childRef}
      children={() => (
        <Switch>
          <AppRoute exact path="/privacypolicy" component={PrivacyPolicy}  />
          <AppRoute exact path="/termsofuse" component={TermsOfUse}  />
          <AppRoute path="/bookmarks" component={Home} layout={LayoutDefault} />
          <AppRoute path="/" component={Home} layout={LayoutDefault} />
        </Switch>
      )} />
  );
}

export default App;